export default {
  mediaUploadImage: "Seleziona un file immagine",
  mediaUploadVideo: "Seleziona un file video",
  mediaUploadEither: "Seleziona un file immagine o video",
  mediaUploadMax: "Il file deve essere inferiore a {{max}}",
  mediaUploadSuccess: "{{type}} caricato",
  storageUploadProcessing: "Salvataggio sul server...",
  storageUploadPercent: "{{percent}}%",
  storageUploadTooLarge: "File troppo grande. Dimensione massima {{max}}.",
  storageUploadFailed: "Impossibile caricare il file",
  storageUploadFailedNamed: "Caricamento non riuscito: {{name}}",
  storageUploadFileProgress:
    "Caricamento di {{name}} ({{current}} di {{total}})",
  mediaUploadButton: "Carica",
  imageCrop: {
    title: "Ritaglia foto",
    confirm: "Usa foto",
    cancel: "Salta",
    zoom: "Zoom",
    failed: "Impossibile ritagliare questa foto. Prova con un’altra immagine.",
  },
  receiptUploadAnalyzing: "Analisi in corso...",
  receiptUploadLabel: "Carica scontrino",
  receiptUploadBeforeVisit:
    "Questa azione è disponibile solo dopo l'inizio della prenotazione",
  receiptUploadTooLarge: "File troppo grande. Dimensione massima {{max}}.",
  receiptUploadUnsupported: "Carica un'immagine o un PDF dello scontrino.",
  receiptModalTitle: "Scontrino caricato",
  receiptModalSubtitle: "Verifica il totale estratto",
  receiptModalExtracted: "Totale estratto dallo scontrino:",
  receiptModalConfirmHint: "Conferma che questo importo è corretto",
  receiptModalMismatch:
    "Questo importo è corretto? Se il totale non coincide con lo scontrino, scegli «Scatta di nuovo».",
  receiptModalConfirming: "Conferma in corso...",
  receiptModalYes: "Sì, è corretto",
  receiptModalRetake: "No, scatta di nuovo",
  receiptOcrFailureTitle: "Impossibile leggere lo scontrino",
  receiptOcrFailureAttemptsRemaining:
    "{{remaining}} di {{max}} tentativi di validazione rimanenti",
  receiptOcrFailureManualHint:
    "La lettura automatica non è riuscita. Puoi caricare un'altra foto o inserire il totale manualmente.",
  receiptOcrFailureRetry: "Carica un'altra foto",
  receiptOcrFailureManualAmount: "Inserisci il totale manualmente",
  receiptPreviewAlt: "Foto dello scontrino",
  receiptViewFull: "Visualizza foto scontrino",
  receiptDownload: "Scarica scontrino",
  receiptDownloadFailed: "Impossibile scaricare lo scontrino. Riprova.",
  attachmentViewFull: "Visualizza immagine",
  attachmentDownload: "Scarica",
  attachmentDownloadFailed: "Impossibile scaricare il file. Riprova.",
  countrySelectSearchPlaceholder: "Cerca paese...",
  countrySelectNoResults: "Nessun paese trovato",
  multiSelectPlaceholder: "Seleziona opzioni...",
  multiSelectRemoveChip: "Rimuovi {{label}}",
  receiptManualAmountTitle: "Inserisci il totale manualmente",
  receiptManualAmountSubtitle:
    "La lettura automatica dello scontrino non è riuscita. Inserisci l'importo totale indicato sullo scontrino.",
  receiptManualAmountLabel: "Totale scontrino (EUR)",
  receiptManualAmountPlaceholder: "es. 42,50",
  receiptManualAmountInvalid: "Inserisci un importo valido maggiore di zero",
  receiptManualAmountSubmit: "Salva totale",
  transactionCustomer: "Cliente:",
  transactionOpenBooking: "Apri prenotazione",
  transactionVisitDate: "Visita del {{date}}",
  walletMovements: {
    badges: {
      income: "Entrata",
      expense: "Uscita",
      settlement: "Liquidazione",
      refund: "Rimborso",
    },
    checkout_payment: {
      title: "Pagamento cliente",
    },
    restaurant_fee: {
      title: "Accredito commissione ristorante",
    },
    refund: {
      title: "Rettifica per rimborso",
    },
    settlement_sent: {
      title: "Liquidazione trasferita sul conto bancario",
      titleWithReference:
        "Liquidazione trasferita sul conto bancario (rif: {{reference}})",
    },
    settlement_received: {
      title: "Liquidazione ricevuta nel portafoglio",
      titleWithReference:
        "Liquidazione ricevuta nel portafoglio (rif: {{reference}})",
    },
    host_payout: {
      title: "Pagamento host",
    },
    host_commission: {
      title: "Commissione",
    },
    sales_agent_commission: {
      title: "Commissione agente di commercio",
    },
    internal_fee: {
      title: "Rettifica commissione piattaforma",
    },
    unknown: {
      title: "Movimento portafoglio",
    },
  },
  translationAllRequired: "Tutte le lingue obbligatorie",
  translationCharCount: "{{current}}/{{max}}",
  translationOverLimit:
    "Una o più lingue superano il limite di {{max}} caratteri. Accorcia il testo nelle lingue in rosso.",
  mediaTypeImage: "Immagine",
  mediaTypeVideo: "Video",
  itemThumbnailAlt: "Immagine elemento",
  productItem: {
    imageTooLarge: "Immagine troppo grande. Dimensione massima 10 MB.",
    menuItemCreated: "Voce di menù creata",
    serviceCreated: "Servizio creato",
    menuItemUpdated: "Voce di menù aggiornata",
    serviceUpdated: "Servizio aggiornato",
    noCategory: "Nessuna categoria",
    titleEditMenu: "Modifica voce menù",
    titleEditService: "Modifica servizio",
    titleAddMenu: "Aggiungi voce al menù",
    titleAddService: "Aggiungi servizio",
    allTranslationsRequired: "Il nome è obbligatorio in tutte le lingue",
    descriptionPartial:
      "La descrizione deve essere vuota oppure tradotta in tutte le lingue",
    autoTranslateHint:
      "Il nome è obbligatorio in tutte le lingue; la descrizione deve essere vuota o completa in tutte le lingue. Compila almeno una lingua, poi genera le traduzioni. Dopo un cambio nome, genera di nuovo per aggiornare le altre lingue.",
    autoTranslateGenerate: "Genera traduzioni",
    autoTranslateConfirmTitle: "Completare le traduzioni mancanti?",
    autoTranslateConfirm:
      "Verranno generate traduzioni solo per le lingue vuote. Il testo esistente non verrà modificato.",
    autoTranslateRefreshTitle: "Aggiornare le altre lingue?",
    autoTranslateRefreshConfirm:
      "Tutte le lingue hanno già un testo. Le altre lingue verranno sostituite con le traduzioni dalla lingua di partenza.",
    autoTranslateApplied: "Traduzioni applicate",
    validPriceRequired: "Inserisci un prezzo valido",
    showKioskDiscountLabel: "Mostra come scontato sui dispositivi",
    showKioskDiscountHint:
      "Il prezzo scontato verrà visualizzato sui dispositivi ed è quello che pagheranno i clienti.",
    undiscountedPriceEuro: "Prezzo non scontato (€)",
    discountedPriceEuro: "Prezzo scontato (€)",
    validUndiscountedPriceRequired: "Inserisci un prezzo non scontato valido",
    validDiscountedPriceRequired: "Inserisci un prezzo scontato valido",
    discountedMustBeLower:
      "Il prezzo scontato deve essere inferiore al prezzo non scontato",
    photo: "Foto",
    photoHint: "Max 10 MB",
    addPhoto: "Aggiungi foto",
    category: "Categoria",
    priceEuro: "Prezzo (€)",
    name: "Nome",
    description: "Descrizione",
    placeholderPriceMenu: "12,50",
    placeholderPriceService: "25,00",
    placeholderNameMenu: "Nome del piatto",
    placeholderNameService: "Nome del servizio",
    placeholderDescMenu: "Descrizione del piatto",
    placeholderDescService: "Descrizione del servizio",
    hintDescMenu: "Facoltativo: ingredienti, preparazione, ecc.",
    hintDescService: "Facoltativo: cosa include il servizio",
    previewAlt: "Anteprima",
    saveChanges: "Salva modifiche",
    addItem: "Aggiungi voce",
    addService: "Aggiungi servizio",
  },
  productItems: {
    menu: {
      title: "Menù",
      emptyTitle: "Nessuna voce nel menù",
      emptySubtitle: "Aggiungi il primo piatto al menù",
      addButton: "Aggiungi voce",
      deleteSuccess: "Voce di menù eliminata",
    },
    service: {
      title: "Servizi offerti",
      emptyTitle: "Nessun servizio ancora",
      emptySubtitle: "Aggiungi i servizi che offri ai clienti",
      addButton: "Aggiungi servizio",
      deleteSuccess: "Servizio eliminato",
    },
    toastDeleteErrorMenu: "Errore nell’eliminazione della voce di menù",
    toastDeleteErrorService: "Errore nell’eliminazione del servizio",
    toastUpdateErrorMenu: "Errore nell’aggiornamento della voce di menù",
    toastUpdateErrorService: "Errore nell’aggiornamento del servizio",
    toastReorderError: "Errore nel riordino degli elementi",
    confirmDelete: "Eliminare «{{name}}»?",
    thisItem: "questo elemento",
    filterAll: "Tutti ({{count}})",
    uncategorized: "Senza categoria ({{count}})",
  },
  transactionsSection: {
    titleDefault: "Movimenti",
    filters: "Filtri",
    dateRange: "Intervallo date",
    activity: "Attività",
    allActivities: "Tutte le attività",
    searchInDescription: "Cerca nella descrizione",
    searchPlaceholder: "Cerca...",
    minAmountEuro: "Importo minimo (€)",
    minAmountPlaceholder: "0,00",
    maxAmountEuro: "Importo massimo (€)",
    noLimit: "Nessun limite",
    reset: "Reimposta",
    applyFilters: "Applica filtri",
    credits: "Entrate",
    debits: "Uscite",
    transactionsCountLabel: "Movimenti",
    loadingTransactions: "Caricamento movimenti...",
    emptyTitle: "Nessun movimento",
    emptyDescription: "Nessun movimento trovato",
  },
  sortableItem: {
    itemAltFallback: "Elemento",
    hidden: "Nascosto",
    hide: "Nascondi",
    show: "Mostra",
    discounted: "Scontato",
  },
} as const;
